import { render } from "./DiabeteResults.vue?vue&type=template&id=5bfb92dd"
import script from "./DiabeteResults.vue?vue&type=script&lang=js"
export * from "./DiabeteResults.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__